import { ITestFormData } from "src/screens/POC/ActionQueue";
import fakeApiAction from "src/screens/POC/ActionQueue/fakeApiAction";

export interface IActionQueueItem {
  key: ActionQueueItemKey;
  data: unknown;
}

export enum ActionQueueItemKey {
  //for testing only
  FAKE_API_REQUEST = "FAKE_API_REQUEST",
  QUEUE_MESSAGE = "QUEUE_MESSAGE",
}

export const onTriggerActionQueueItem = (
  item: IActionQueueItem,
  queueMessageCallback: (message: string) => void
): void => {
  switch (item.key) {
    case ActionQueueItemKey.FAKE_API_REQUEST:
      fakeApiAction(item.data as ITestFormData);
      break;
    case ActionQueueItemKey.QUEUE_MESSAGE:
      queueMessageCallback(item.data as string);
      break;
    default:
      break;
  }
};
